module.exports = __webpack_public_path__ + "static/img/tu2.d907715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu2.png
// module id = 4JZ5
// module chunks = 128